const base_url = process.env.REACT_APP_BASE_URL;

export const getJob = async (id) => {
  const response = await fetch(`${base_url}/jobs/${id}`);
  const job = await response.json();
  return job;
};
